import React from 'react';
import AuthLayout from '../../components/layouts/AuthLayout';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constant/routes';
import { ForgotPasswordForm } from '../../components/ui/ForgotPasswordForm';
import AuthLink from '../../components/common/AuthLink';

const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AuthLayout>
      <div className="authContainer">
        <h1 className="authLogo">Forgot Password</h1>
        <h2 className="forgotPasswordSubtitle">
          Don’t worry, mate! We can restore it for you.
        </h2>
        <ForgotPasswordForm
          onSuccess={(email) =>
            navigate(`${ROUTES.RESET_PASSWORD}?email=${encodeURIComponent(email)}`)
          }
        />
      </div>

      <AuthLink
        text="Remember your password?"
        linkText="sign in."
        linkTo={ROUTES.LOGIN}
      />
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
